export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7625.139777f1.jpg";